//
// Copyright 2021 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React, {useState} from "react";
import {makeStyles} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import * as Config from "eai-configurator-ui/components/configuration/utils/ConfigurationRegistry";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Item from "@material-ui/core/Grid";
import DataSourcesButton from "src/components/loader/buttons/DataSourcesButton";
import CopyLayoutButton from "src/components/loader/buttons/CopyLayoutButton";
import FixLayoutButton from "src/components/loader/buttons/FixLayoutButton";
import ExportLayoutButton from "src/components/loader/buttons/ExportLayoutButton";
import ImportLayoutButton from "src/components/loader/buttons/ImportLayoutButton";
import LayoutUsageButton from "src/components/loader/buttons/LayoutUsageButton";
import LayoutActionImportButton from "src/components/loader/buttons/LayoutActionImportButton";
import ConfigurationAsyncComboBox from "eai-configurator-ui/components/configuration/base/ConfigurationAsyncComboBox";
import TreeView from "eai-configurator-ui/components/base/TreeView";
import BusinessIcon from "@material-ui/icons/Business";
import SaveConfigurationButton from "src/components/loader/buttons/SaveConfigurationButton";
import Paper from "@material-ui/core/Paper";
import {useDropzone} from "react-dropzone";
import Button from "@material-ui/core/Button";
import FilesIcon from "@material-ui/icons/FileCopy";
import ConfigurationCheckBox from "eai-configurator-ui/components/configuration/base/ConfigurationCheckBox";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  textField: {
    width: "100%",
  },
  error: {
    color: "red",
  },
  checkbox: {
    paddingLeft: 0,
  },
  paper: {
    padding: 10,
  },
  button: {
    margin: 4,
  },
  expandablePanelIcon: {
    margin: 4,
  },
  expandablePanel: {
    paddingLeft: 10,
  },
  input: {
    display: "none",
  },
  dropzone: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "5px",
    borderWidth: 2,
    borderRadius: 2,
    borderColor: "#eeeeee",
    borderStyle: "dashed",
    backgroundColor: "#fafafa",
    color: "#bdbdbd",
    outline: "none",
    transition: "border .24s ease-in-out",
  },
}));
const LayoutPage = ({navigateToResults, dropzoneOptions}) => {
  const classes = useStyles();

  //
  const [nameMappingDataSource, setNameMappingDataSource] = React.useState(
    Config.fromPath("loader:layout:nameMappingDataSource", true).data.value
  );
  const [sourceDataSource, setSourceDataSource] = React.useState(
    Config.fromPath("loader:layout:fromDataSource", true).data.value
  );
  const [destDataSource, setDestDataSource] = React.useState(
    Config.fromPath("loader:layout:toDataSource", true).data.value
  );
  const [usageDataSource, setUsageDataSource] = React.useState(
    Config.fromPath("loader:layout:usageDataSource", true).data.value
  );

  //
  const [exportDataSource, setExportDataSource] = React.useState(
    Config.fromPath("loader:layout:exportDataSource", true).data.value
  );
  const [importDataSource, setImportDataSource] = React.useState(
    Config.fromPath("loader:layout:importDataSource", true).data.value
  );
  const [actionImportDataSource, setActionImportDataSource] = React.useState(
    Config.fromPath("loader:layout:actionImportDataSource", true).data.value
  );

  // region Name mapping file handling

  const [selectedNameMappingFiles, setSelectedNameMappingFiles] = useState([]);
  const selectedNameMappingFilesItems = selectedNameMappingFiles.map((file) => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));

  const {
    getRootProps: getRootPropsNameMappingFile,
    getInputProps: getInputPropsNameMappingFile,
    open: handleOpenNameMappingFileSelection,
  } = useDropzone({
    // accept: 'image/jpeg, image/png'
    onDrop: (files) => setSelectedNameMappingFiles(files),
    multiple: false,
    ...dropzoneOptions,
  });

  const clearSelectedNameMappingFiles = () => {
    setSelectedNameMappingFiles([]);
  };

  // endregion

  // region Import file handling

  const [selectedImportFiles, setSelectedImportFiles] = useState([]);
  const selectedImportFilesItems = selectedImportFiles.map((file) => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));

  const {
    getRootProps: getRootPropsImportFile,
    getInputProps: getInputPropsImportFile,
    open: handleOpenImportFileSelection,
  } = useDropzone({
    // accept: 'image/jpeg, image/png'
    onDrop: (files) => setSelectedImportFiles(files),
    multiple: false,
    ...dropzoneOptions,
  });

  const clearSelectedImportFiles = () => {
    setSelectedImportFiles([]);
  };

  // endregion

  // region action import file handling

  const [selectedActionImportFiles, setSelectedActionImportFiles] = useState([]);
  const selectedActionImportFilesItems = selectedActionImportFiles.map((file) => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));

  const {
    getRootProps: getRootPropsActionImportFile,
    getInputProps: getInputPropsActionImportFile,
    open: handleOpenActionImportFileSelection,
  } = useDropzone({
    // accept: 'image/jpeg, image/png'
    onDrop: (files) => setSelectedActionImportFiles(files),
    multiple: false,
    ...dropzoneOptions,
  });

  const clearSelectedActionImportFiles = () => {
    setSelectedActionImportFiles([]);
  };

  // endregion

  const [
    dataSourceRefreshCounter,
    setDataSourceRefreshCounter,
  ] = React.useState(0);

  const handleSelectNameMappingDataSource = (dataSourceName) => {
    setNameMappingDataSource(dataSourceName);
  };
  const handleSelectSourceDataSource = (dataSourceName) => {
    setSourceDataSource(dataSourceName);
  };
  const handleSelectDestDataSource = (dataSourceName) => {
    setDestDataSource(dataSourceName);
  };
  const handleSelectUsageDataSource = (dataSourceName) => {
    setUsageDataSource(dataSourceName);
  };
  const handleSelectExportDataSource = (dataSourceName) => {
    setExportDataSource(dataSourceName);
  };
  const handleSelectImportDataSource = (dataSourceName) => {
    setImportDataSource(dataSourceName);
  };
  const handleSelectActionImportDataSource = (dataSourceName) => {
    setActionImportDataSource(dataSourceName);
  };
  const handleCloseDataSourceDialog = (dataSourceName) => {
    setDataSourceRefreshCounter(dataSourceRefreshCounter + 1);
  };

  return (
    <React.Fragment>
      <div>
        <Typography variant="body2" color="textSecondary">
          <h5>P6 Layout Engine</h5>
          <hr/>
        </Typography>

        <Paper className={classes.paper}>
          <Typography variant="body2" color="textSecondary">
            <h6>Configure data sources</h6>
          </Typography>
          <Typography variant="caption" color="textSecondary">
            Use this button to configure the data sources used by layout engine:
          </Typography>
          <Box m={1}>
            <DataSourcesButton
              className={classes.button}
              handleClosed={handleCloseDataSourceDialog}
            />
          </Box>
        </Paper>

        <hr/>

        <Paper className={classes.paper}>
          <Typography variant="body2" color="textSecondary">
            <h6>Name mapping file export</h6>
          </Typography>
          <Typography variant="caption" color="textSecondary">
            Use this button to export the name mapping file:
          </Typography>
          <Grid container>
            <Item xs={4}>
              <ConfigurationAsyncComboBox
                fullWidth
                path={"loader:layout:nameMappingDataSource"}
                url={"loader/dataSources"}
                autoSelect={false}
                transformHttpResponse={(data) => {
                  return {
                    options: data.dataSources.map((dataSource) => dataSource.name),
                  };
                }}
                handleChanged={handleSelectNameMappingDataSource}
              />
            </Item>
            <Item xs={4} style={{textAlign: 'left'}}>
              <SaveConfigurationButton
                style={{marginLeft: 10, marginTop: 8}}
                label="Export Name Mapping File"
                url="loader/exportNameMappingFile"
                disabled={!Boolean(nameMappingDataSource)}
                handleSuccess={navigateToResults}
                icon={<BusinessIcon/>}
              />
            </Item>
          </Grid>
        </Paper>

        <hr/>

        <Paper className={classes.paper}>
          <Typography variant="body2" color="textSecondary">
            <h6>Layout copy/ fix</h6>
          </Typography>
          <Typography variant="caption" color="textSecondary">
            Use this area to submit a job to copy layouts from the 'From Data Source' to the 'To Data Source', or to fix layouts in the 'From Data Source'.
            <br/>
            Select the 'From Data Source' to populate the layout list.
            <br/>
            You can optionally select a name translation file if the codes, UDFs or other object names are different between the source and target databases.
            <br/>
            <b>IMPORTANT:</b> If the layouts being copied use global, project or user filters, you <b>must</b> submit a job to copy just the filters,
            and then another job to copy the layouts.
          </Typography>

          <div key={dataSourceRefreshCounter}>
            <Grid container style={{marginTop: 10}}>
              <Item xs={3}>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  startIcon={<FilesIcon/>}
                  onClick={handleOpenNameMappingFileSelection}
                >
                  Choose Name Mapping File
                </Button>
              </Item>
              <Item xs={6}>
                <div {...getRootPropsNameMappingFile({className: classes.dropzone})}>
                  <input {...getInputPropsNameMappingFile()} />
                  <p>Drag 'n' drop some files here, or click to select files</p>
                </div>
                <aside>
                  <ul>{selectedNameMappingFilesItems}</ul>
                </aside>
              </Item>
            </Grid>
            <Grid container style={{marginTop: 10}}>
              <Item xs={4}>
                <ConfigurationAsyncComboBox
                  fullWidth
                  path={"loader:layout:fromDataSource"}
                  url={"loader/dataSources"}
                  autoSelect={false}
                  transformHttpResponse={(data) => {
                    return {
                      options: data.dataSources.map((dataSource) => dataSource.name),
                    };
                  }}
                  handleChanged={handleSelectSourceDataSource}
                />
              </Item>
              <Item xs={4} style={{textAlign: 'left'}}>
                <FixLayoutButton
                  style={{marginTop: 28, width: 300, marginLeft: 5}}
                  className={classes.button}
                  submitEmptyRequest
                  selectedFiles={selectedNameMappingFiles}
                  clearSelectedFiles={clearSelectedNameMappingFiles}
                  disabled={!Boolean(sourceDataSource)}
                  handleSuccess={navigateToResults}
                />
              </Item>
            </Grid>
            <Grid container>
              <Item xs={4}>
                <ConfigurationAsyncComboBox
                  fullWidth
                  disabled={!Boolean(sourceDataSource)}
                  path={"loader:layout:toDataSource"}
                  url={"loader/dataSources"}
                  autoSelect={false}
                  transformHttpResponse={(data) => {
                    return {
                      options: data.dataSources.map((dataSource) => dataSource.name),
                    };
                  }}
                  handleChanged={handleSelectDestDataSource}
                />
              </Item>
              <Item xs={4} style={{textAlign: 'left'}}>
                <CopyLayoutButton
                  style={{marginTop: 28, width: 300, marginLeft: 5}}
                  className={classes.button}
                  submitEmptyRequest
                  selectedFiles={selectedNameMappingFiles}
                  clearSelectedFiles={clearSelectedNameMappingFiles}
                  disabled={!Boolean(sourceDataSource) || !Boolean(destDataSource)}
                  handleSuccess={navigateToResults}
                />
              </Item>
            </Grid>
            <Typography variant="caption" color="textSecondary">
              Use the option <b>Overwrite Existing Layouts</b> to overwrite layouts when making a copy.
              <br/>
              Use the option <b>Fix invalid gantt bar layout filter references</b> to fix gantt bars that have a filter active but the filter is not selectable
              by the user. This option will make the filter also be present under the available filters in the layout data, which may fix this issue.
            </Typography>
            <Grid container>
              <Item xs={12} style={{textAlign: 'left'}}>
                <ConfigurationCheckBox path={"loader:layout:overwriteExistingLayouts"}/>
                <ConfigurationCheckBox path={"loader:layout:fixInvalidGanttBarLayoutFilterReferences"}/>
              </Item>
            </Grid>
          </div>
          {sourceDataSource && (
            <>
              <br/>
              <Typography variant="body2">
                Select the layouts to copy or fix:
              </Typography>
              <TreeView
                path={"loader:layout:copyLayouts"}
                url={
                  "loader/layoutTree?dataSourceName=" +
                  encodeURIComponent(sourceDataSource)
                }
              />
            </>
          )}
        </Paper>

        <hr/>

        <Paper className={classes.paper}>
          <Typography variant="body2" color="textSecondary">
            <h6>Layout usage report</h6>
          </Typography>
          <Typography variant="caption" color="textSecondary">
            Use this area to submit a job to show how reports and layouts are being used.
            <br/>
            Select the data source to populate the layout list.
            <br/>
            This tool will only report on the filters and layouts selected.
          </Typography>

          <div key={dataSourceRefreshCounter}>
            <Grid container style={{marginTop: 10}}>
              <Item xs={4}>
                <ConfigurationAsyncComboBox
                  fullWidth
                  path={"loader:layout:usageDataSource"}
                  url={"loader/dataSources"}
                  autoSelect={false}
                  transformHttpResponse={(data) => {
                    return {
                      options: data.dataSources.map((dataSource) => dataSource.name),
                    };
                  }}
                  handleChanged={handleSelectUsageDataSource}
                />
              </Item>
            </Grid>
            <Grid container>
              <Item xs={3} style={{textAlign: 'left'}}>
                <LayoutUsageButton
                  style={{marginTop: 4}}
                  className={classes.button}
                  submitEmptyRequest
                  selectedFiles={selectedNameMappingFiles}
                  clearSelectedFiles={clearSelectedNameMappingFiles}
                  disabled={!Boolean(usageDataSource)}
                  handleSuccess={navigateToResults}
                />
              </Item>
            </Grid>
          </div>
          {usageDataSource && (
            <>
              <br/>
              <Typography variant="body2">
                Select the layouts to report from:
              </Typography>
              <TreeView
                path={"loader:layout:usageLayouts"}
                url={
                  "loader/layoutTree?dataSourceName=" +
                  encodeURIComponent(usageDataSource)
                }
              />
            </>
          )}
        </Paper>

        <hr/>

        <Paper className={classes.paper}>
          <Typography variant="body2" color="textSecondary">
            <h6>Layout - import action sheet from usage report</h6>
          </Typography>
          <Typography variant="caption" color="textSecondary">
            Use this area to import a spreadsheet with layout actions to be executed. These actions
            are entered in the sheets generated from the [Usage Report] area.
          </Typography>

          <div key={dataSourceRefreshCounter}>
            <Grid container style={{marginTop: 10}}>
              <Item xs={3}>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  startIcon={<FilesIcon/>}
                  onClick={handleOpenActionImportFileSelection}
                >
                  Choose Layout Action Import File
                </Button>
              </Item>
              <Item xs={6}>
                <div {...getRootPropsActionImportFile({className: classes.dropzone})}>
                  <input {...getInputPropsActionImportFile()} />
                  <p>Drag 'n' drop some files here, or click to select files</p>
                </div>
                <aside>
                  <ul>{selectedActionImportFilesItems}</ul>
                </aside>
              </Item>
            </Grid>

            <Grid container style={{marginTop: 10}}>
              <Item xs={4}>
                <ConfigurationAsyncComboBox
                  fullWidth
                  path={"loader:layout:actionImportDataSource"}
                  url={"loader/dataSources"}
                  autoSelect={false}
                  transformHttpResponse={(data) => {
                    return {
                      options: data.dataSources.map((dataSource) => dataSource.name),
                    };
                  }}
                  handleChanged={handleSelectActionImportDataSource}
                />
              </Item>
              <Item xs={3} style={{textAlign: 'left'}}>
                <LayoutActionImportButton
                  style={{marginLeft: 10, marginTop: 8}}
                  className={classes.button}
                  selectedFiles={selectedActionImportFiles}
                  disabled={selectedActionImportFilesItems.length === 0 || !Boolean(actionImportDataSource)}
                  clearSelectedFiles={clearSelectedActionImportFiles}
                  handleSuccess={navigateToResults}
                />
              </Item>
            </Grid>
          </div>
        </Paper>

        <hr/>

        <Paper className={classes.paper}>
          <Typography variant="body2" color="textSecondary">
            <h6>Layout export</h6>
          </Typography>
          <Typography variant="caption" color="textSecondary">
            Use this area to submit a job to export layouts from the selected data source.
            <br/>
            This is useful to make a backup copy of the layouts, however the remapping functionality to fix layouts is not available for exports/ imports.
            You can only restore these layouts to the database they originated from.
          </Typography>

          <div key={dataSourceRefreshCounter}>
            <Grid container style={{marginTop: 10}}>
              <Item xs={4}>
                <ConfigurationAsyncComboBox
                  fullWidth
                  path={"loader:layout:exportDataSource"}
                  url={"loader/dataSources"}
                  autoSelect={false}
                  transformHttpResponse={(data) => {
                    return {
                      options: data.dataSources.map((dataSource) => dataSource.name),
                    };
                  }}
                  handleChanged={handleSelectExportDataSource}
                />
              </Item>
              <Item xs={3} style={{textAlign: 'left'}}>
                <ExportLayoutButton
                  style={{marginLeft: 10, marginTop: 8}}
                  className={classes.button}
                  disabled={!Boolean(exportDataSource)}
                  clearSelectedFiles={clearSelectedNameMappingFiles}
                  handleSuccess={navigateToResults}
                />
              </Item>
            </Grid>
          </div>
          {exportDataSource && (
            <>
              <br/>
              <Typography variant="body2">
                Select the layouts to export:
              </Typography>
              <TreeView
                path={"loader:layout:exportLayouts"}
                url={
                  "loader/layoutTree?dataSourceName=" +
                  encodeURIComponent(exportDataSource)
                }
              />
            </>
          )}
        </Paper>

        <hr/>

        <Paper className={classes.paper}>
          <Typography variant="body2" color="textSecondary">
            <h6>Layout import</h6>
          </Typography>
          <Typography variant="caption" color="textSecondary">
            Use this area to submit a job to import layouts from the selected data source.
            <br/>
            You should export and import layouts from/ to the same database.
          </Typography>

          <div key={dataSourceRefreshCounter}>
            <Grid container style={{marginTop: 10}}>
              <Item xs={3}>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  startIcon={<FilesIcon/>}
                  onClick={handleOpenImportFileSelection}
                >
                  Choose Layout Import File
                </Button>
              </Item>
              <Item xs={6}>
                <div {...getRootPropsImportFile({className: classes.dropzone})}>
                  <input {...getInputPropsImportFile()} />
                  <p>Drag 'n' drop some files here, or click to select files</p>
                </div>
                <aside>
                  <ul>{selectedImportFilesItems}</ul>
                </aside>
              </Item>
            </Grid>

            <Grid container style={{marginTop: 10}}>
              <Item xs={4}>
                <ConfigurationAsyncComboBox
                  fullWidth
                  path={"loader:layout:importDataSource"}
                  url={"loader/dataSources"}
                  autoSelect={false}
                  transformHttpResponse={(data) => {
                    return {
                      options: data.dataSources.map((dataSource) => dataSource.name),
                    };
                  }}
                  handleChanged={handleSelectImportDataSource}
                />
              </Item>
              <Item xs={3} style={{textAlign: 'left'}}>
                <ImportLayoutButton
                  style={{marginLeft: 10, marginTop: 8}}
                  className={classes.button}
                  selectedFiles={selectedImportFiles}
                  disabled={selectedImportFilesItems.length === 0 || !Boolean(importDataSource)}
                  clearSelectedFiles={clearSelectedImportFiles}
                  handleSuccess={navigateToResults}
                />
              </Item>
            </Grid>
          </div>
        </Paper>

      </div>
    </React.Fragment>
  );
};
export default LayoutPage;
